export const sendChatMessage = async (
    prompt: string,
    userId: string,
    onChunk: (chunk: string) => void,
    mode: string = "affiliate"
) => {
    const supabaseUrl = import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
    const anonKey = import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

    if (!supabaseUrl || !anonKey) {
        throw new Error("Supabase environment variables are missing.");
    }

    const response = await fetch(`${supabaseUrl}/functions/v1/chat`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${anonKey}`,
            apikey: anonKey,
        },
        body: JSON.stringify({ prompt, userId, mode }),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || "Error connecting to chat service");
    }

    if (!response.body) {
        throw new Error("No response body received");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let done = false;

    while (!done) {
        const { value, done: doneReading } = await reader.read();
        done = doneReading;
        if (value) {
            const chunk = decoder.decode(value, { stream: true });
            onChunk(chunk);
        }
    }
};
